import { gql } from "@apollo/client";

export const UPDATE_USER_ROLE = gql`
  mutation UpdateUser($id: ID!, $role: String, $size: String) {
    updateUser(id: $id, role: $role, size: $size) {
      id
      role
      size
    }
  }
`;